import { Directive } from '@angular/core';

/**
 * Scrollable content container of a modal.
 *
 * @example
 * ```html
 * <div modal-content></div>
 * // or
 * <modal-content></modal-content>
 * ```
 */
@Directive({
    selector: `modal-content, [modalContent]`,
    host: { class: 'modal-content' },
    standalone: true
})
export class ModalContentDirective {}
